import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "service/ApiService";
import { notify } from "service/NotificationService";

export default function ProductsSelector({ onChange, selectedIds }) {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleError = (error) => notify("Error", error);

  const fetchData = async () => {
    try {
      const dataResponse = await apiService.get(`api/products`);
      setOptions(dataResponse.map((item) => ({ value: item._id, label: item.name })));

      if (selectedIds) {
        const selectedOptions = options.filter((option) => selectedIds.includes(option.value));
        setSelectedOptions(selectedOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      handleError(error.message);
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "2.75rem",
      border: "none",
    }),
  };

  useEffect(() => {
    fetchData();
  }, [selectedIds]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    const selectedIds = selectedOptions.map((option) => option.value);
    onChange(selectedIds);
  };

  return (
    <>
      <Select
        styles={customStyles}
        className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
        isMulti
        options={options}
        noOptionsMessage={() => "No products available"}
        value={selectedOptions}
        onChange={handleChange}
        placeholder="Select products"
      />
    </>
  );
}
